import request from '@/utils/http'

const PREFIX = '/panel'

const panelComponent = {
  // 添加组件
  addComponent(params) {
    return request(
      `${PREFIX}/addComponent`,
      'post',
      params
    )
  },
  // 更新组件
  updateComponent(params) {
    return request(
      `${PREFIX}/updateComponent`,
      'post',
      params
    )
  },
  // 获取单个组件ByID
  getComponentById(params) {
    return request(
      `${PREFIX}/getComponentById`,
      'post',
      params
    )
  },
  // 获取组件列表
  getComponentList(params) {
    return request(
      `${PREFIX}/getComponentList`,
      'post',
      params
    )
  },
  // 获取书签列表
  getBookmarkList(params) {
    return request(
      `${PREFIX}/getBookmarkList`,
      'post',
      params
    )
  },
  // 删除单个组件
  deleteComponent(componentId) {
    return request(
      `${PREFIX}/deleteComponent/` + componentId,
      'delete'
    )
  },
  // 获取概览列表分页
  getOverviewListPage(params) {
    return request(
      `${PREFIX}/getOverviewListPage`,
      'post',
      params
    )
  },
  // 获取概览列表
  getOverviewList(currentProjectId) {
    return request(
      `${PREFIX}/getOverviewList/` + currentProjectId,
      'get'
    )
  },
  // 获取概览列表
  getOverviewsByIds(param) {
    return request(
      `${PREFIX}/getOverviewsByIds`,
      'get',
      param
    )
  },
  // 添加概览
  addOverviewPanel(params) {
    return request(
      `${PREFIX}/addOverview`,
      'post',
      params
    )
  },
  // 删除概览
  deleteOverview(overviewId) {
    return request(
      `${PREFIX}/deleteOverview/` + overviewId,
      'delete'
    )
  },
  // 删除标签
  deleteBookmark(id) {
    return request(
      `${PREFIX}/bookmark/${id}`,
      'delete'
    )
  },
  // 更新概览
  updateOverview(params) {
    return request(
      `${PREFIX}/updateOverview`,
      'post',
      params
    )
  },
  // 删除概览组件关系
  deleteComponentOverview(params) {
    return request(
      `${PREFIX}/deleteComponentOverview`,
      'delete',
      params
    )
  },
  // 保存概览组件关系
  saveComponentOverview(params) {
    return request(
      `${PREFIX}/saveComponentOverview`,
      'post',
      params
    )
  },
  // 获取书签列表不含当前概览
  getBookmarkListExclude(params) {
    return request(
      `${PREFIX}/getBookmarkListExclude`,
      'post',
      params
    )
  },
  // 获取分享当前项目概览分页列表
  getShareOverviewListPage(param) {
    return request(
      `${PREFIX}/getShareOverviewListPage`,
      'post',
      param
    )
  },
  // 添加项目内所有用户分享概览关系
  addUserOverviewProject(params) {
    return request(
      `${PREFIX}/addUserOverviewProject`,
      'post',
      params
    )
  },
  // 添加分享用户概览关系
  addUserOverview(params) {
    return request(
      `${PREFIX}/addUserOverview`,
      'post',
      params
    )
  },
  // 更新书签动态时间窗口展示状态
  changeDynamic(params) {
    return request(
      `${PREFIX}/changeDynamic`,
      'post',
      params
    )
  },
  // 更新概览组件显示顺序
  updComponentPosition(params) {
    return request(
      `${PREFIX}/updComponentPosition`,
      'put',
      params
    )
  },
  // 更新概览组件的尺寸
  updComponentSize(param) {
    return request(
      `${PREFIX}/updComponentSize`,
      'put',
      param
    )
  },
  // 获取概览绑定的用户ID
  getUserIdsByOverviewId(id) {
    return request(
      `${PREFIX}/overview/users/${id}`,
      'get'
    )
  }
}

export default panelComponent
